import PropTypes from 'prop-types';
import React from 'react';

import Button from 'components/Button';
import Message from 'components/Message';
import { SvgArrow } from 'components/Svgs';
import { bem } from 'helpers/class-name';

import './ClassLevelConfigureSection.scss';

const { block, element } = bem('class-level-configure-section');

const ClassLevelConfigureSection = ({ onConfigureClick, configureTitle, configureDescription, configure }) => {
  return (
    <div className={block()}>
      <div className={element('content')}>
        <div className={element('text-container')}>
          <Message as="h3" className={element('title')} message={configureTitle} />
          <Message as="p" className={element('description')} message={configureDescription} />
        </div>
        <Button
          className={element('configure-button')}
          styled="tertiary"
          onClick={onConfigureClick}
          type={Button.TYPES.BUTTON}>
          <Message message={configure} />
          <SvgArrow className={element('caret-right')} direction="right" />
        </Button>
      </div>
    </div>
  );
};

ClassLevelConfigureSection.propTypes = {
  onConfigureClick: PropTypes.func.isRequired,
  configureTitle: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }).isRequired,
  configureDescription: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }).isRequired,
  configure: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }).isRequired,
};

export default ClassLevelConfigureSection;
